import { render, staticRenderFns } from "./ManageAmazonOrders.vue?vue&type=template&id=589c121c&scoped=true&"
import script from "./ManageAmazonOrders.vue?vue&type=script&lang=js&"
export * from "./ManageAmazonOrders.vue?vue&type=script&lang=js&"
import style0 from "./ManageAmazonOrders.vue?vue&type=style&index=0&id=589c121c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589c121c",
  null
  
)

export default component.exports